var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,20c16.569,0,30,13.431,30,30S66.569,80,50,80S20,66.569,20,50S33.431,20,50,20 M50,15   c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S69.299,15,50,15L50,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.698,69.543c-3.064,0-4.694-1.775-5.772-2.951c-0.975-1.062-1.307-1.331-2.088-1.331c-0.782,0-1.092,0.252-2.079,1.33   c-1.077,1.176-2.705,2.952-5.768,2.952c-3.062,0-4.689-1.776-5.766-2.952c-0.987-1.078-1.298-1.33-2.08-1.33   c-0.781,0-1.091,0.252-2.078,1.33c-1.077,1.176-2.704,2.952-5.766,2.952c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5   c0.781,0,1.091-0.252,2.078-1.33c1.077-1.176,2.704-2.952,5.766-2.952s4.689,1.776,5.767,2.952c0.987,1.078,1.297,1.33,2.079,1.33   c0.782,0,1.093-0.252,2.081-1.33c1.076-1.176,2.704-2.952,5.766-2.952c3.063,0,4.693,1.775,5.771,2.95   c0.975,1.062,1.308,1.332,2.089,1.332c1.381,0,2.5,1.119,2.5,2.5S67.079,69.543,65.698,69.543z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.198,38.999c3.038,0,5.5,2.462,5.5,5.5c0,3.038-2.462,5.5-5.5,5.5s-5.5-2.462-5.5-5.5   C57.698,41.462,60.16,38.999,63.198,38.999 M63.198,33.999c-5.79,0-10.5,4.71-10.5,10.5s4.71,10.5,10.5,10.5s10.5-4.71,10.5-10.5   S68.988,33.999,63.198,33.999L63.198,33.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.802,38.999c3.038,0,5.5,2.462,5.5,5.5c0,3.038-2.462,5.5-5.5,5.5s-5.5-2.462-5.5-5.5   C31.302,41.462,33.765,38.999,36.802,38.999 M36.802,33.999c-5.79,0-10.5,4.71-10.5,10.5s4.71,10.5,10.5,10.5s10.5-4.71,10.5-10.5   S42.592,33.999,36.802,33.999L36.802,33.999z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.802,
    cy: 44.499,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.198,
    cy: 44.499,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.e16a3c4e406feda0844f6b4d721374f9.svg";
export { ForwardRef as ReactComponent };